import WellsScore from "../../../../src/client/katnh/widgets/WellsScore.js";
import * as React from 'react';
export default {
  WellsScore,
  React
};